import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionBrushEditCommon from '../../../redux/action/FJActionBrushEditCommon';
import {
    setSliceDisableReset,
    setSliceEditImageLoadStatus,
    setSliceIsMouseMove,
} from '../../../redux/slices/FJSliceBrushEditCommon';
import { FJViewCanvasSingleton } from '../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJMobileCreationEdit from './FJMobileCreationEdit';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const FJMobileCreationEditContainer = ({ containerHeight }) => {
    useLocalStore();
    const dispatch = useDispatch();
    const editImage = useSelector(state => state.brushEditCommon.editImage);
    const brushSize = useSelector(state => state.brushEditCommon.brushSize);
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMouseMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const zoom = useSelector(state => state.brushEditCommon.zoom);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isShowBrushInCenter = useSelector(state => state.brushEditCommon.isShowBrushInCenter);
    const isSlideCompare = useSelector(state => state.brushEditCommon.isSlideCompare);
    const mobileCanDraw = useSelector(state => state.brushEditCommon.mobileCanDraw);
    const editImageLoadStatus = useSelector(state => state.brushEditCommon.editImageLoadStatus);

    // 编辑的图是否存在
    const isInEditImage = useMemo(() => {
        return editImage && editImage.src && editImage.src !== '';
    }, [editImage]);

    const isShowEditCanvas = useMemo(() => {
        return editImageLoadStatus === FJConstant.SUCCESS && taskStatus === FJConstant.DEFAULT && isInEditImage;
    }, [taskStatus, editImageLoadStatus, isInEditImage]);

    useEffect(() => {
        FJViewCanvasSingleton.mouseEventType = curBrushType;

        if (isShowEditCanvas) {
            FJViewCanvasSingleton.draw();
        }
    }, [curBrushType, isShowEditCanvas]);

    useEffect(() => {
        FJViewCanvasSingleton.isMove = isMouseMove;
    }, [isMouseMove]);

    useEffect(() => {
        FJViewCanvasSingleton.setBrushSize(brushSize);
    }, [brushSize]);

    const _setZoom = useCallback(
        (zoom, e, isFitClick = false) => {
            FJViewCanvasSingleton.setZoom(zoom, e, { isFitClick });
            dispatch(FJActionBrushEditCommon.updateZoomAction());
            dispatch(FJActionBrushEditCommon.updateEditImageRectAction());
        },
        [dispatch],
    );

    const initViewCanvas = useCallback(
        async (canvas, viewSize) => {
            dispatch(setSliceEditImageLoadStatus(FJConstant.LOADING));
            let loadSuccess = false;
            const hasEditImage = editImage && editImage.src !== '';
            try {
                if (hasEditImage) {
                    await FJViewCanvasSingleton.init(canvas, editImage.src, viewSize);
                    loadSuccess = true;
                    dispatch(setSliceEditImageLoadStatus(FJConstant.SUCCESS));
                }
            } catch (e) {
                loadSuccess = false;
                dispatch(setSliceEditImageLoadStatus(FJConstant.ERROR));
            }
            dispatch(FJActionBrushEditCommon.editImageLoadedAfterAction(loadSuccess));
        },
        [editImage, dispatch],
    );

    const mouseDownHandler = useCallback(
        (e, mouseInToolPanel) => {
            const isUpdateView = FJViewCanvasSingleton.mouseDownHandler(e, { mouseInToolPanel, drawStart: false });

            if (isUpdateView) {
                dispatch(setSliceDisableReset(false));
                dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
            }
        },
        [dispatch],
    );

    const mouseUpHandler = useCallback(
        (e, mouseInToolPanel) => {
            const isUpdateView = FJViewCanvasSingleton.mouseUpHandler(e, { mouseInToolPanel });
            dispatch(FJActionBrushEditCommon.updateDisableFitButtonAction());
            if (isUpdateView) {
                dispatch(setSliceDisableReset(false));
                dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
            }
        },
        [dispatch],
    );

    const mouseMoveHandler = useCallback(
        (e, mouseInToolPanel) => {
            FJViewCanvasSingleton.mouseMoveHandler(e, mouseInToolPanel);
            if (isSlideCompare && isMouseMove) {
                dispatch(FJActionBrushEditCommon.updateEditImageRectAction());
            }
        },
        [dispatch, isSlideCompare, isMouseMove],
    );
    const changeIsMouseMove = useCallback(
        bool => {
            dispatch(setSliceIsMouseMove(bool));
        },
        [dispatch],
    );

    return (
        <FJMobileCreationEdit
            initViewCanvas={initViewCanvas}
            mouseDownHandler={mouseDownHandler}
            mouseUpHandler={mouseUpHandler}
            mouseMoveHandler={mouseMoveHandler}
            curBrushType={curBrushType}
            isMouseMove={isMouseMove}
            brushSize={brushSize}
            zoom={zoom}
            isShowBrushInCenter={isShowBrushInCenter}
            setZoom={_setZoom}
            isShowEditCanvas={isShowEditCanvas}
            changeIsMouseMove={changeIsMouseMove}
            mobileCanDraw={mobileCanDraw}
            containerHeight={containerHeight}
        />
    );
};

FJMobileCreationEditContainer.propTypes = {
    containerHeight: PropTypes.string,
};

export default FJMobileCreationEditContainer;
